const history = () => {
    let pos = { top: 0, left: 0, x: 0, y: 0 };
    const $content = $(".about-history .history-content");
    const $range = $(".about-history .historyRange")
    let maxPos = $content.find(".history-container").outerWidth() - $content.outerWidth();

    let active = false;

    const drag = function (e) {
        if (!active) return

        let currentX;
        if (e.type === "touchmove") {
            currentX = e.touches[0].clientX;
        } else {
            currentX = e.clientX;
        }
        const dx = currentX - pos.x;
        const newPos = pos.left - dx;
        $content.scrollLeft(newPos);

    };

    const dragStart = function (e) {
        active = true;

        let currentX;
        if (e.type === "touchstart") {
            currentX = e.touches[0].clientX;
        } else {
            currentX = e.clientX;
        }

        pos = {
            left: $content.scrollLeft(),
            x: currentX,
        };
    };

    const dragEnd = function () {
        active = false

    }

    const updateRangeOnScroll = function (e) {
        const newPos = $content.scrollLeft()
        const percent = Math.round(newPos / maxPos * 100);
        $range.val(percent)
    }

    const rangeOnChange = function () {
        const percent = $(this).val();
        const newPos = Math.round(maxPos * percent / 100)
        $content.scrollLeft(newPos);
    }

    const mouseWheelAction = function () {
        $content.mousewheel(function (event, delta) {
            //console.log( delta, event.deltaX, event.deltaY, event.deltaFactor);
            //$content.scrollLeft(newPos);
            $content.scrollLeft($(this).scrollLeft() - delta);
            event.preventDefault();
        });
    }
    function init() {
        $content.on("touchstart", dragStart);
        $content.on("touchend", (e) => dragEnd(e));
        $content.on("touchmove", drag);

        $content.on("mousedown", dragStart);
        $content.on("mouseup mouseleave", (e) => dragEnd(e));
        $content.on("mousemove", drag);
        $content.on("scroll", updateRangeOnScroll)
        $range.on("input", rangeOnChange)
        $(window).on("resize", function () {
            maxPos = $content.find(".history-container").outerWidth() - $content.outerWidth();
        })
        mouseWheelAction();
    }
    init();
}

module.exports = history